import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  FaArrowLeft,
  FaPhone,
  FaPhoneAlt,
  FaClock,
  FaPlay,
  FaCheckCircle,
  FaTimesCircle,
  FaPhoneSlash,
} from "react-icons/fa";

import { viewCallDetail } from "../../../redux/services/Ai Services/Ai.Services";
import Pagination from "../../../common/Pagination";
function ViewCallDetail() {
  const { phone } = useParams();
  
  const navigate = useNavigate();

  const [callData, setCallData] = useState(null);
  const [loading, setLoading] = useState(true);

  const formatDateTime = (date) => {
    if (!date) return "-";
    const parsedDate = new Date(date.replace(" ", "T"));
    if (Number.isNaN(parsedDate.getTime())) return date;

    return parsedDate.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDuration = (seconds) => {
    if (!seconds || seconds <= 0) return "0 sec";
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) return `${mins} min ${secs} sec`;
    return `${secs} sec`;
  };

  const getStatusIcon = (status) => {
    const s = status?.toLowerCase();
    if (s === "completed" || s === "success" || s === "answered")
      return <FaCheckCircle />;
    if (s === "failed" || s === "rejected" || s === "cancelled")
      return <FaTimesCircle />;
    if (s === "calling") return <FaPhoneAlt />;
    return <FaPhone />;
  };

  const getStatusClass = (status) => {
    const s = status?.toLowerCase();
    if (s === "completed" || s === "success" || s === "answered")
      return "status-success";
    if (s === "failed" || s === "rejected" || s === "cancelled")
      return "status-danger";
    return "status-calling";
  };

useEffect(() => {
  const fetchCallDetails = async () => {
    try {
      setLoading(true);

      // normalize: strip +91 / 91 prefix, keep last 10 digits
      const cleanMobile = (phone || "").replace(/\D/g, "").slice(-10);

      const response = await viewCallDetail(cleanMobile);
      const data = response?.data ?? response;

      setCallData(data?.success === false ? null : (data?.data ?? data ?? null));
    } catch (error) {
      console.error("Error fetching call details:", error);
      setCallData(null);
    } finally {
      setLoading(false);
    }
  };

  if (phone) fetchCallDetails();
}, [phone]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h5 className="mt-3">Loading Call Details...</h5>
      </div>
    );
  }

  if (!callData) {
    return (
      <div className="text-center py-5">
        <h5>No Call Details Found</h5>
        <div className="d-flex justify-content-end mt-3">
          <button className="btn btn-primary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const callHistory = callData?.all_calls_history || [];

  return (
    <>
      {/* PAGE HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Call Details</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Call Details</span>
          </nav>
        </div>

        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button className="add-btn" onClick={() => navigate(-1)}>
            <FaArrowLeft className="me-2" />
            Back
          </button>
        </div>
      </div>

      <div className="main_page">
        <div className="call-chat-wrapper">
          {/* Header */}
          <div className="chat-header">
            <div className="chat-user-avatar">
              {callData?.name?.charAt(0)?.toUpperCase() || "U"}
            </div>
            <div className="chat-user-info">
              <h5>{callData?.name || "Unknown User"}</h5>
              <div className="chat-phone">
                <FaPhone size={11} />
                <span>{callData?.phone || phone}</span>
              </div>
            </div>
            <div className="chat-header-right">
              <span
                className={`current-status ${getStatusClass(
                  callData?.call_status
                )}`}
              >
                {callData?.call_status || "-"}
              </span>
              <div className="total-calls">
                {callData?.total_calls_count || 0} Calls
              </div>
            </div>
          </div>

          {/* Body */}
          <div className="chat-body">
            {callHistory.length === 0 ? (
              <div className="no-call-history">
                <FaPhoneSlash size={10} />
                <h5>No Call History</h5>
                <p>There is no call history available for this lead.</p>
              </div>
            ) : (
              callHistory.map((call, index) => {
                const transcript =
                  call.conversation_transcript ||
                  callData?.conversation_transcript ||
                  [];

                const recordingUrl =
                  call.recording_url || callData?.recording_url || "";

                return (
                  <div
                    className="call-message-row"
                    key={call.call_session_id || index}
                  >
                    <div className="chat-date">
                      {formatDateTime(call.called_at)}
                    </div>

                    <div className="call-bubble">
                      <div className="call-bubble-header">
                        <div className="call-icon">
                          {getStatusIcon(call.call_status)}
                        </div>
                        <div className="call-title">
                          <strong>AI Call</strong>
                          <span>{call.call_status || "-"}</span>
                        </div>
                        <div className="call-number">#{index + 1}</div>
                      </div>

                      <div className="call-info">
                        <div className="call-info-item">
                          <FaClock />
                          <div>
                            <small>Duration</small>
                            <strong>
                              {formatDuration(call.call_duration_seconds)}
                            </strong>
                          </div>
                        </div>

                        <div className="call-info-item">
                          <FaPhone />
                          <div>
                            <small>Status</small>
                            <strong>{call.call_status || "-"}</strong>
                          </div>
                        </div>
                      </div>

                      {recordingUrl && (
                        <div className="call-recording">
                          <div className="recording-title">
                            <FaPlay />
                            <span>Call Recording</span>
                          </div>
                          <audio controls src={recordingUrl}>
                            Your browser does not support audio playback.
                          </audio>
                        </div>
                      )}

                      {transcript?.length > 0 && (
                        <div className="transcript-section">
                          <div className="transcript-title">Conversation</div>
                          <div className="transcript-messages">
                            {transcript.map((message, messageIndex) => {
                              const speaker =
                                message?.speaker ||
                                message?.role ||
                                message?.sender ||
                                "Unknown";
                              const text =
                                message?.text ||
                                message?.message ||
                                message?.content ||
                                "";
                              const time = message?.time || "";
                              const isAI =
                                speaker?.toLowerCase() === "ai" ||
                                speaker?.toLowerCase() === "assistant";

                              return (
                                <div
                                  key={messageIndex}
                                  className={`transcript-message ${
                                    isAI ? "ai-message" : "user-message"
                                  }`}
                                >
                                  <div className="message-speaker">
                                    {isAI ? "AI" : "User"}
                                    {time && (
                                      <span className="message-time">
                                        {time}
                                      </span>
                                    )}
                                  </div>
                                  <div className="message-text">{text}</div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <div className="bubble-time">
                        {formatDateTime(call.called_at)}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

 
    </>
  );
}

export default ViewCallDetail;